<script>
  import {s3linkfrom} from "../EndpointsAndTransforms";
  export let name;
  $: link = s3linkfrom(name)
</script>

<img src={link} />

<style>
  img {
    max-width: 100%;
    object-fit: contain;
    max-height: 100%;
    filter: drop-shadow(5px 7px 5px #272d35);
  }
</style>
